import React, { useState } from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { formService } from '../../_services/form.service';


const FormSharingPopup = (props) => {
  const isSalonOwner = props?.user?.userInfo?.hairdresser?.isSalonOwner === 1;

  const teamOptions = isSalonOwner
    ? [
        { value: 1, label: 'Share forms with self employed staff' },
        { value: 0, label: 'Don\'t share forms with self employed staff' },
      ]
    : [
        { value: 1, label: 'Share forms with other staff' },
        { value: 0, label: 'Don\'t share forms with other staff' },
      ];

  const [shareTeamMember, setShareTeamMember] = useState(
    teamOptions.find(option => option.value === props.selectedSetting) || teamOptions.find(option => option.value === 1) || teamOptions[0]
  );

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderColor: '#ccc',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#707070',
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#29282e' : 'white',
      color: state.isSelected ? 'white' : '#333',
      '&:hover': {
        backgroundColor: state.isSelected ? '#29282e' : '#f0f0f0',
      },
    }),
  };

  const handleApply = () => {
    formService.formShareSetting({ shareForm: shareTeamMember.value })
      .then(() => {
        if (props.onApply) {
          props.onApply(shareTeamMember.value);
        }
        props.onHide();
      })
      .catch((error) => {
        console.error('Error saving form sharing settings:', error);
        // Still close and apply locally on error
        if (props.onApply) {
          props.onApply(shareTeamMember.value);
        }
        props.onHide();
      });
  };

  return (
    <div className="filters-popup pb-0">
      <div className="filter-group">
        <label>Form Sharing</label>
        <Select
          menuPlacement="top"
          classNamePrefix="my-select"
          value={shareTeamMember}
          onChange={setShareTeamMember}
          options={teamOptions}
          styles={customStyles}
          isSearchable={false}
        />
      </div>
      <div className="filter-actions text-right mt-5">
        <button className="btn btn-outline-dark pl-4 pr-4" onClick={() => props.onHide()}>Cancel</button>
        <button className="btn btn-dark ml-4 pl-4 pr-4" onClick={handleApply}>Apply</button>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    ...state
  };
}

export default connect(mapStateToProps)(FormSharingPopup);
